// Sentry must initialise before anything else renders (side-effect import).
import "./instrument.ts";
// Global stylesheets are linked from `root.tsx` (`links`), not imported here.
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { marketingRedirect } from "./utils/marketingSites.ts";
import {
  preparePlayrHydration,
  preparePlayrLinks,
  type HydrationRoutes,
} from "./utils/playrHydration.ts";

// Normalize copied legacy URLs before the router reads the browser location.
const destination = marketingRedirect(new URL(window.location.href));
if (destination && new URL(destination).origin !== window.location.origin) {
  window.location.replace(destination);
} else {
  if (destination)
    window.history.replaceState(window.history.state, "", destination);
  // The bootstrap manifest is populated by React Router's <Scripts> before
  // importing this entry. Keep the PLAYR prerender's route chain on its host.
  const manifest = (
    window as Window & { __reactRouterManifest?: { routes: HydrationRoutes } }
  ).__reactRouterManifest;
  if (preparePlayrHydration(manifest?.routes, new URL(window.location.href)))
    preparePlayrLinks(document);
  startTransition(() => {
    const app = (
      <StrictMode>
        <HydratedRouter />
      </StrictMode>
    );
    hydrateRoot(document, app);
  });
}
